<style lang="scss">
@import './stylesheets/main.scss';
</style>

<template>
  <div id="qsuper-modeller" :class="{ loaded: loaded }">
    <div class="navigation top-level-navigation">
      <div class="row">
        <ul>
          <li>
            <router-link :to="{ name: 'about' }">About</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'results' }">Results</router-link>
          </li>
          <!-- <li>
            <router-link :to="{ name: 'next-steps' }">Next steps</router-link>
          </li> -->
        </ul>

        <div class="header-right show-for-large" :class="{ 'about-page': $route.path.indexOf('/about/') >= 0 }">
          <div class="print-page">
            <router-link :to="{ name: 'print' }">
              <i class="fa fa-print" aria-hidden="true"></i> Print</router-link>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>

    <div class="preload-images hide" v-show="false">
      <img src="./assets/super-sorted.png" />
    </div>

    <div class="javascript-media-queries">
      <div class="show-for-small"></div>
      <div class="show-for-small-only"></div>
      <div class="show-for-medium"></div>
      <div class="show-for-medium-only"></div>
      <div class="show-for-large"></div>
      <div class="show-for-large-only"></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import store from './store';
import bus from './events';

export default {
  store,
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    postParentMessage(data, targetOrigin = '*') {
      this.$nextTick(() => {
        const localData = typeof data === 'function' ? data() : data;
        window.parent.postMessage(localData, targetOrigin);
      });
    },
    postScrollTopEvent() {
      document.body.scrollTop = 0;
      this.postParentMessage({ type: 'scrollTop' });
    },
    postResizeEvent() {
      this.postParentMessage(() => ({
        type: 'resize',
        height: this.$el.clientHeight,
        width: this.$el.clientWidth,
      }));
    },
  },
  watch: {
    $route() {
      this.postResizeEvent();
    },
  },
  mounted() {
    window.addEventListener('resize', _.throttle(this.postResizeEvent, 100), true);

    bus.$on('scrollTop', _.throttle(this.postScrollTopEvent, 100));
    bus.$on('resize', _.throttle(this.postResizeEvent, 100));

    this.loaded = true;
  },
};
</script>
